import {FieldType} from '../../../../models/field-type';
import {FormConfig} from '../../../../models/form-config';
import {OwnerDataConsts} from '../../../../../core/consts/owner-data.consts';
import {getDrivingLicenseIssueYears} from '../../../../utils/driving-license-years';
import {OwnerDataSectionConfig} from '../owner-data-section.config';
import {
  PredefinedValuesService
} from '../../../../../core/services/impl/section-services/predefined-values/predefined-values.service';
import {Validator} from '../../../../models/validator.enum';
import {OwnerDataConfig} from '../owner-data.config';
import {MaterialDatepickerType} from '../../../../enums/material-datepicker-type.enum';
import {
  OwnerDataStateService
} from '../../../../../core/services/impl/section-services/owner-data/owner-data-state.service';
import {RegExpKey, RegExpService} from '../../../../services/reg-exp.service';

export class CoOwnerConfig extends OwnerDataSectionConfig {

  constructor(public predefined: PredefinedValuesService,
              public stateService: OwnerDataStateService,
              public regExpService: RegExpService) {
    super();
  };


  public createCoOwnerConfig(): FormConfig {
    const drivingLicenseIssueYears = getDrivingLicenseIssueYears(OwnerDataConfig.START_YEAR);
    const formConfig =  <FormConfig> {
      formKey: 'CO_OWNER_DATA_SECTION',
      fieldsConfig: [
        {
          fieldKey: OwnerDataConsts.PARTY_CODE_TYPE,
          caption: 'OWNER_DATA_SECTION.FORM_FIELDS.firstName',
          type: FieldType.TextField,
          validators: [
            Validator.REQUIRED_NOT_BLANK,
            {
              name: Validator.PATTERN,
              pattern: this.regExpService.getRegExp(RegExpKey.CITY)
            },
            {
              name: Validator.MAX_LENGTH,
              maxLength: 100
            },
            {
              name: Validator.MIN_LENGTH,
              minLength: 3
            }],
          properties: {
            textTransform: {
              type: 'capitalize'
            }
          }
        },
        {
          fieldKey: OwnerDataConsts.FIRST_NAME,
          caption: 'OWNER_DATA_SECTION.FORM_FIELDS.firstName',
          type: FieldType.TextField,
          personalData: true,
          displayInPreviewMode: true,
          validators: [
            Validator.REQUIRED_NOT_BLANK,
            {
              name: Validator.PATTERN,
              pattern: this.regExpService.getRegExp(RegExpKey.FIRST_NAME)
            },
            {
              name: Validator.MAX_LENGTH,
              maxLength: 100
            },
            {
              name: Validator.MIN_LENGTH,
              minLength: 2
            }],
          autocomplete: 'given-name',
          properties: {
            textTransform: {
              type: 'capitalize'
            },
          }
        },
        {
          fieldKey: OwnerDataConsts.LAST_NAME,
          caption: 'OWNER_DATA_SECTION.FORM_FIELDS.lastName',
          type: FieldType.TextField,
          personalData: true,
          displayInPreviewMode: true,
          validators: [
            Validator.REQUIRED_NOT_BLANK,
            {
              name: Validator.PATTERN,
              pattern: this.regExpService.getRegExp(RegExpKey.LAST_NAME)
            },
            {
              name: Validator.MAX_LENGTH,
              maxLength: 100
            },
            {
              name: Validator.MIN_LENGTH,
              minLength: 2
            }],
          autocomplete: 'family-name',
          properties: {
            textTransform: {
              type: 'capitalize'
            },
          }
        },
        {
          fieldKey: OwnerDataConsts.PESEL,
          caption: 'OWNER_DATA_SECTION.FORM_FIELDS.pesel',
          // description: 'OWNER_DATA_SECTION.TOOLTIP.pesel',
          type: FieldType.TextField,
          personalData: true,
          displayInPreviewMode: true,
          validators: [
            Validator.REQUIRED,
            Validator.PESEL,
          ],
          maskConfig: {
            mask: '00000000000'
          },
          properties: {
            mobileInputType: 'tel',
          }
        },
        {
          fieldKey: OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR,
          caption: 'OWNER_DATA_SECTION.FORM_FIELDS.drivingLicenseIssueYear',
          type: FieldType.DateField,
          validators: [Validator.REQUIRED],
          displayInPreviewMode: true,
          materialDateFieldConfig: {
            startView: 'multi-year',
            type: MaterialDatepickerType.YEAR,
            startAt: this.stateService.DRIVING_LICENSE_ISSUE_YEAR_START_YEAR,
            datepickerToggleIcon: 'arrow_drop_down',
            hideCalendarPeriodButton: true,
            initMinDateWithStartAt: false,
            minDate: drivingLicenseIssueYears.length > 0 ? Math.min(...getDrivingLicenseIssueYears(OwnerDataConfig.START_YEAR)) + '' : null,
            maxDate: drivingLicenseIssueYears.length > 0 ? Math.max(...getDrivingLicenseIssueYears(OwnerDataConfig.START_YEAR)) + '' : null,
            manualInputAllowed: true,
            readonly: false,
          }
        },
        {
          fieldKey: OwnerDataConsts.NO_DRIVING_LICENSE,
          caption: 'OWNER_DATA_SECTION.FORM_FIELDS.noDrivingLicense',
          type: FieldType.Checkbox,
          displayInEditableMode: false,
          checkboxConfig: {
            readonly: false
          },
          // analyticsConfig: {
          //   customFieldName: 'OWNER_DATA_SECTION.FORM_FIELDS.drivingLicenseIssueYear',
          //   customFieldValue: () => {
          //     if (this.stateService.noDrivingLicense) {
          //       return this.languageService.translateService.instant('OWNER_DATA_SECTION.FORM_FIELDS.noDrivingLicense');
          //     }
          //     return this.stateService.ownerData.drivingLicenseIssueYear;
          //   }
          // }
        },
        {
          fieldKey: OwnerDataConsts.DRIVING_LICENSE_ISSUE_MONTH,
          caption: 'OWNER_DATA_SECTION.FORM_FIELDS.drivingLicenseIssueMonth',
          type: FieldType.Select,
          displayInEditableMode: false,
          displayInPreviewMode: true,
          validators: [],
          options: {
            item: 'key',
            label: { label: 'label' },
            items: []
          },
          select: {
            dropdownPosition: 'bottom',
            multiple: false,
            searchable: true
          }
        },
        {
          fieldKey: OwnerDataConsts.POSTAL_CODE,
          caption: 'OWNER_DATA_SECTION.FORM_FIELDS.postalCode',
          type: FieldType.TextField,
          displayInPreviewMode: true,
          validators: [
            Validator.REQUIRED_NOT_BLANK,
            Validator.POSTAL_CODE,
            {
              name: Validator.PATTERN,
              pattern: this.regExpService.getRegExp(RegExpKey.POSTAL_CODE)
            }],
          maskConfig: {
            mask: '00-000',
            dropSpecialCharacters: false
          },
          autocomplete: 'postal-code',
          properties: {
            mobileInputType: 'tel',
          },
          analyticsConfig: {
            includeFieldValue: true
          }
        }
      ]
    };


    formConfig.fieldsConfig.forEach(fieldConfig => {
      this.predefined.addPredefinedValue(
        fieldConfig,
        this.predefined.values,
        formConfig.formKey,
        fieldConfig.fieldKey
      )
    });

    return this.createConfig(formConfig)
  }
}
